'use client';

import React from 'react';
import Image from 'next/image';
import { cn } from '@/lib/utils';
import SectionHeading from '../layout/section-heading';
import ContactActionButtons from '@/components/contact-actions';

export default function OfferHero({
    className,

    // ✅ NEW: alignment control
    // "contentLeft"  => content left, image right (default)
    // "contentRight" => content right, image left
    alignment = 'contentLeft',

    titleClassName,
    descriptionClassName,
    title = '',
    description = ``,

    // Right image
    imageClassWrapper = '',
    productImageSrc = '/images/offer-books.png',
    productImageAlt = 'Book and tablet mockup',
    actionsButtons = true,
}) {
    const isContentRight = alignment === 'contentRight';

    return (
        <section className={cn('', className)}>
            <div className="container">
                <div
                    className={cn(
                        'lg:flex lg:gap-16 gap-8 justify-center items-center',
                        // ✅ flip on desktop only
                        isContentRight && 'lg:flex-row-reverse'
                    )}
                >
                    {/* CONTENT */}
                    <div className={cn('relative z-10 lg:w-1/2')}>
                        <h2 className={cn('fs-54 font-semibold mb-10', titleClassName)}>{title}</h2>
                        {description ? (
                            <div
                                className={cn(
                                    'fs-62 text-foreground text-left',
                                    descriptionClassName
                                )}
                            >
                                {description}
                            </div>
                        ) : null}
                        {actionsButtons && (
                            <div className={cn('mt-10', isContentRight && 'lg:flex')}>
                                <ContactActionButtons
                                    show={['chat', 'call']}
                                    onChat={() => window?.Tawk_API?.maximize?.()}
                                    phone="+15408938895"
                                    chatVariant="default"
                                    callVariant="secondary"
                                    size="3xl"
                                    classBtn1="max-sm:w-full"
                                    classBtn2="max-sm:w-full"
                                />
                            </div>
                        )}
                    </div>

                    {/* IMAGE */}
                    <div className="relative mx-auto flex justify-center items-center lg:w-1/2 max-lg:mt-10">
                        <div className={cn('relative w-full', imageClassWrapper)}>
                            <Image
                                src={productImageSrc}
                                alt={productImageAlt}
                                width={560}
                                height={520}
                                className="h-auto max-w-full w-full mx-auto object-contain"
                                priority={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
